import styled from 'styled-components';

export const StyledAddOnCardContainer = styled.div`
  background-color: ${props => props.theme.colors.background.bone};
  border-radius: ${props => props.theme.spacing(8)};
  width: 100%;
  @media ${props => props.theme.tablet} {
    max-width: ${props => props.theme.spacing(50)};
  }
`;

export const StyledImageContainer = styled.div`
  display: none;
  @media ${props => props.theme.tablet} {
    max-height: 37%;
    display: block;
  }
`;

export const StyledCardContent = styled.div`
  display: none;
  @media ${props => props.theme.tablet} {
    display: block;
    padding: ${props => props.theme.spacing(2, 6, 6)};
  }
`;

export const StyledTitle = styled.h3`
  ${props => props.theme.typography.heading4}
  text-align: left;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const StyledAddOnCardDescription = styled.p`
  ${props => props.theme.typography.body}
  color: ${props => props.theme.colors.neutral.darkerFur};
  text-align: left;
  margin-bottom: ${props => props.theme.spacing(5)};
`;

export const MobileCardContent = styled.div`
  width: 100%;
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const MobileImageContainer = styled.div`
  width: 100%;
  border-radius: ${props => props.theme.spacing(8)};
  padding: ${props => props.theme.spacing(0, 6)};
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;
